import React from 'react';

// 为了在 Web React 环境中兼容 __DEV__ 判断，这里自定义一个 __DEV__ 标志
// 如果打包工具（如 webpack、Vite）提供了 process.env.NODE_ENV，会按其判断
// 否则默认认为是开发环境（true），以保留调试告警能力
var __DEV__ = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV)
  ? process.env.NODE_ENV !== 'production'
  : true;

// 动态颜色值：根据 isDark 选择 light 或 dark
export class DynamicColorValue {
  constructor(light, dark) {
    this.light = light;
    this.dark = dark;
  }

  current(isDark) {
    return isDark ? this.dark : this.light;
  }
}

// 原来类里的静态方法改为类外赋值，避免使用 static 关键字
DynamicColorValue.dyc = function (light, dark) {
  return new DynamicColorValue(light, dark);
};

DynamicColorValue.dyCurrentImage = function (imageInfo, isDark) {
  if (__DEV__ && typeof isDark === 'undefined') {
    throw new Error('注意 dyCurrentImage isDark没有传值');
  }
  if (!isDark) {
    return imageInfo.light;
  }
  if (!imageInfo.dark) {
    return imageInfo.light;
  }
  return imageInfo.dark;
};

// 使用 ES5 兼容的方式挂载静态字段，避免使用 class fields 语法
DynamicColorValue.dyc_ff4338 = new DynamicColorValue('#ff4338', '#ff564d');
DynamicColorValue.dyc_f4f5f7_bg = new DynamicColorValue('#f4f5f7', '#121212');
DynamicColorValue.dyc_f4f5f7_fg = new DynamicColorValue('#f4f5f7', '#242424');
DynamicColorValue.dyc_111111 = new DynamicColorValue('#111111', '#f0f0f0');
DynamicColorValue.dyc_f7f7f7 = new DynamicColorValue('#f7f7f7', '#2e2e2e');
DynamicColorValue.dyc_ffffff_fg = new DynamicColorValue('#ffffff', '#242424');
DynamicColorValue.dyc_ffffff_bg = new DynamicColorValue('#ffffff', '#121212');
DynamicColorValue.dyc_333333 = new DynamicColorValue('#333333', '#e0e0e0');
DynamicColorValue.dyc_555555 = new DynamicColorValue('#555555', '#d4d4d4');
DynamicColorValue.dyc_444444 = new DynamicColorValue('#444444', '#d4d4d4');
DynamicColorValue.dyc_666666 = new DynamicColorValue('#666666', '#a8a8a8');
DynamicColorValue.dyc_888888 = new DynamicColorValue('#888888', '#e0e0e0');
DynamicColorValue.dyc_999999 = new DynamicColorValue('#999999', '#808080');
DynamicColorValue.dyc_cacaca = new DynamicColorValue('#cacaca', '#4f4f4f');
DynamicColorValue.dyc_eaeaea = new DynamicColorValue('#eaeaea', '#424242');
DynamicColorValue.dyc_f0f0f0 = new DynamicColorValue('#f0f0f0', 'rgba(255, 255, 255, 0.06)');
DynamicColorValue.dyc_f7f7f9 = new DynamicColorValue('#f7f7f9', '#222222');
DynamicColorValue.dyc_fafafa = new DynamicColorValue('#fafafa', '#1f1f1f');
DynamicColorValue.dyc_test_red = new DynamicColorValue('red', 'blue');
DynamicColorValue.dyc_000000 = new DynamicColorValue('#000000', '#e0e0e0');
DynamicColorValue.dyc_4f87c4 = new DynamicColorValue('#4f87c4', '#7693B9');
DynamicColorValue.dyc_b16724 = new DynamicColorValue('#b16724', '#d5b186');
DynamicColorValue.dyc_f7f8fa = new DynamicColorValue('#F7F8FA', '#242424');

export class DYColorMapper {}

// 将原来的静态方法改为类外赋值，避免使用 static 关键字
DYColorMapper.dyc = function (key, isDark) {
  if (__DEV__ && typeof isDark === 'undefined') {
    throw new Error('注意 DYColorMapper.dyc isDark没有传值');
  }
  if (!key) {
    return key;
  }
  var upperKey = String(key).toUpperCase();
  var value = DYColorMapper.__map[upperKey];
  if (!value) {
    if (__DEV__) {
      console.warn('DYColorMapper do not contain this key', upperKey);
    }
    return upperKey;
  }
  return isDark ? value.dark : value.light;
};

DYColorMapper.dyCurrentImage = function (imageInfo, isDark) {
  if (__DEV__ && typeof isDark === 'undefined') {
    throw new Error('注意 dyCurrentImage isDark没有传值');
  }
  if (!isDark) {
    return imageInfo.light;
  }
  if (!imageInfo.dark) {
    return imageInfo.light;
  }
  return imageInfo.dark;
};

// 使用 ES5 方式定义 __map，避免 class field 语法
DYColorMapper.__map = {
  '#000000': DynamicColorValue.dyc_000000,
  '#F7F7F9': DynamicColorValue.dyc_f7f7f9,
  '#FF4338': DynamicColorValue.dyc_ff4338,
  '#F4F5F7_BG': DynamicColorValue.dyc_f4f5f7_bg,
  '#F4F5F7_FG': DynamicColorValue.dyc_f4f5f7_fg,
  '#111111': DynamicColorValue.dyc_111111,
  '#F7F7F7': DynamicColorValue.dyc_f7f7f7,
  '#FFFFFF_BG': DynamicColorValue.dyc_ffffff_bg,
  '#FFFFFF_FG': DynamicColorValue.dyc_ffffff_fg,
  '#333333': DynamicColorValue.dyc_333333,
  '#555555': DynamicColorValue.dyc_555555,
  '#444444': DynamicColorValue.dyc_444444,
  '#666666': DynamicColorValue.dyc_666666,
  '#888888': DynamicColorValue.dyc_888888,
  '#999999': DynamicColorValue.dyc_999999,
  '#CACACA': DynamicColorValue.dyc_cacaca,
  '#EAEAEA': DynamicColorValue.dyc_eaeaea,
  '#F0F0F0': DynamicColorValue.dyc_f0f0f0,
  '#4F87C4': DynamicColorValue.dyc_4f87c4,
  '#B16724': DynamicColorValue.dyc_b16724,
  '#F7F8FA': DynamicColorValue.dyc_f7f8fa,
  red: DynamicColorValue.dyc_test_red,
};

// Web 版本的 getColorSchemeStyle：不再依赖 React Native 的 StyleSheet.create
// 直接返回普通 JS 对象形式的样式，同时保持原来按 light/dark 缓存结果的行为
export function getColorSchemeStyle(dynamicStyleSheet, isDark) {
  if (__DEV__ && typeof isDark === 'undefined') {
    throw new Error('getColorSchemeStyle isDark没有传值');
  }

  if (isDark) {
    if (!dynamicStyleSheet.__dark) {
      dynamicStyleSheet.__dark = parseStylesFor(dynamicStyleSheet, 'dark');
      if (__DEV__) {
        console.log('parseStylesFor dark');
      }
    }
    return dynamicStyleSheet.__dark;
  } else {
    if (!dynamicStyleSheet.__light) {
      dynamicStyleSheet.__light = parseStylesFor(dynamicStyleSheet, 'light');
      if (__DEV__) {
        console.log('parseStylesFor light');
      }
    }
    return dynamicStyleSheet.__light;
  }
}

function parseStylesFor(styles, mode) {
  var newStyles = {};
  var containsDynamicColorValues = false;

  for (var key in styles) {
    if (!Object.prototype.hasOwnProperty.call(styles, key)) continue;
    var style = styles[key];

    // 跳过内部缓存字段，避免无限递归或污染
    if (key === '__dark' || key === '__light') {
      continue;
    }

    var newStyle = {};
    for (var prop in style) {
      if (!Object.prototype.hasOwnProperty.call(style, prop)) continue;
      var value = style[prop];
      if (value instanceof DynamicColorValue) {
        containsDynamicColorValues = true;
        newStyle[prop] = value[mode];
      } else {
        newStyle[prop] = value;
      }
    }
    newStyles[key] = newStyle;
  }

  if (!containsDynamicColorValues && __DEV__) {
    console.warn(
      'A DYCStyleSheet was used without any DynamicColorValues. Consider replacing with a regular StyleSheet.'
    );
  }

  return newStyles;
}



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/ColorSchemeV2/index.js